import { Box, Typography, Divider } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

export interface ActivityLogEntry {
  timestamp: string;
  description: string;
}

interface ActivityLogProps {
  activities: ActivityLogEntry[];
}

export const ActivityLog: React.FC<ActivityLogProps> = ({ activities }) => {
  const { colors } = useCelleraTheme();

  const formatDate = (dateString: string) => {
    return dayjs(dateString).format("MMM DD, YYYY HH:mm");
  };

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border.light}`,
        borderRadius: "8px",
        p: 3,
        backgroundColor: colors.background.paper,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mb: 3,
        }}
      >
        Activity Log
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {activities.map((activity, index) => (
          <Box key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: colors.text.secondary,
                  fontSize: "0.75rem",
                  fontWeight: 500,
                }}
              >
                {formatDate(activity.timestamp)}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: colors.text.primary,
                }}
              >
                {activity.description}
              </Typography>
            </Box>
            {index < activities.length - 1 && (
              <Divider
                sx={{
                  mt: 2,
                  borderColor: colors.border.light,
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
